<template>

	<div class="row justify-content-center">
		<div class="col-xl-5 col-lg-5 col-md-5 col-sm-6">
			<!-- Used to display form errors. -->


			<form @submit.prevent="submit" :action="`/pay/confirm/stripe/payment`" method="post" id="payment-form">
				<loading :active="loading"
						 :can-cancel="false"
						 loader="dots"
						 color="#2292ef"
						 :is-full-page="true"></loading>
				<div v-if="errorMessage" class="alert alert-danger m-auto" role="alert">
					<i class="fa fa-bug"></i> {{errorMessage}}
				</div>

				<div class="row mt-5">
					<div class="col-xl-12 col-lg-12">
						<div class="form-group">
							<label for="name_on_card">Name on card</label>
							<input type="text" id="name_on_card" class="form-control form-account"
								   name="name_on_card" v-model="name_on_card"
								   placeholder="Type your name on card">
						</div>
					</div>
					<div class="col-xl-12 col-lg-12">
						<div class="form-group">
							<label for="card-element">
								Credit or debit card
							</label>
							<div id="card-element">
								<!-- A Stripe Element will be inserted here. -->
							</div>
						</div>
					</div>
					<div v-if="loading===false" class="col-xl-12 col-lg-12">
						<div class="row d-flex">
							<div class="col-xl-12 col-lg-12">
								<button type="submit" class="btn btn-primary" id="submit-btn">Submit Payment
								</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import Swal from "sweetalert2";
	import Loading from 'vue-loading-overlay';
	import 'vue-loading-overlay/dist/vue-loading.css';

	export default {
		components: {
			Loading
		},
		props: [
			'pk',
			'intent_id',
			'client_secret',
            'csrf',
		],
		data() {
			return {
				stripe: null,
				card: null,
				loading: false,
				errorMessage: null,
				name_on_card: ''
			}
		},
		created() {
			// Create a Stripe client.
			this.stripe = Stripe(this.pk);
		},
		mounted() {
			let self = this;
			// Create an instance of Elements.
			let elements = this.stripe.elements();
			let style = {
				base: {
					color: '#32325d',
					fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
					fontSmoothing: 'antialiased',
					fontSize: '16px',
					'::placeholder': {
						color: '#aab7c4'
					}
				},
				invalid: {
					color: '#fa755a',
					iconColor: '#fa755a'
				}
			};

			// Create an instance of the card Element.
			this.card = elements.create('card', {
				style: style,
				hidePostalCode: true
			});

			// Add an instance of the card Element into the `card-element` <div>.
			this.card.mount('#card-element');

			// Handle real-time validation errors from the card Element.
			this.card.addEventListener('change', function (event) {
				if (event.error) {
					self.errorMessage = event.error.message;
				} else {
					self.errorMessage = null;
				}
			});
		},
		methods: {
			submit: function () {
				if (this.name_on_card == '' || this.name_on_card == null) {
					this.errorMessage = "Name on card field is required";
				} else {
					this.loading = true;
					let form = document.getElementById('payment-form');
					let button = $('#submit-btn');
					let self = this;
					this.stripe.confirmCardPayment(self.client_secret,

						{
							payment_method: {
								card: self.card,
								billing_details: {
									name: self.name_on_card
								}
							}
						}
					).then(function (result) {
						if (result.error) {
							self.loading = false;
							self.errorMessage = result.error.message;
						} else {
							if (result.paymentIntent.status === 'succeeded') {
								console.log('payment succeeded');
								let form = document.getElementById('payment-form');
								let hiddenInput = document.createElement('input');
								let csrfInput = document.createElement('input');
								hiddenInput.setAttribute('type', 'hidden');
								hiddenInput.setAttribute('name', 'intent_id');
								hiddenInput.setAttribute('value', self.intent_id);
								csrfInput.setAttribute('type', 'hidden');
								csrfInput.setAttribute('name', '_token');
								csrfInput.setAttribute('value', self.csrf);
								form.appendChild(hiddenInput);
								form.appendChild(csrfInput);
								form.submit();
							} else {
								self.loading = false;
								console.log('payment error');
							}
						}
					});
				}
			}

		},
		remove: function (route) {
			let formData = new FormData();
			formData.append("_method", "delete");
			Swal.fire({
				type: "question",
				text: `Do you really want to delete this ?`,
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				showCancelButton: true,
				showCloseButton: true
			}).then(result => {
				if (result.value) {
					axios({
						method: "post",
						url: route + "?_method=DELETE",
						data: formData
					})
						.then(function (response) {
							// delete
							Swal.fire({
								type: "success",
								text: `Deleted`,
							});
							location.reload();
						})
						.catch(function (err) {
							let errors = err.response.data.errors;
							console.log(errors);
						});
				}
			});
		}

	}
</script>
